import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { withFeatureFlags } from '@atlassian/mpac-ui';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../common/constants/proptypes/CommonPropTypes";
import AddonDiscoveryPropTypes from "../constants/proptypes/AddonDiscoveryPropTypes";
import { resolveDiscoverHeadingText } from "../utils/headings";
import TextSearchWrapper from "./common/TextSearch/TextSearchWrapper";

class HeroWrapper extends Component {
  render() {
    var _this$props;

    const Hero = this.props.heroComponent;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextSearchWrapper, {
      filters: this.props.filters,
      searchComponent: Hero,
      extraProps: {
        discoverHeading: resolveDiscoverHeadingText({
          filters: this.props.filters,
          featureFlags: {
            enableJsdToJsm: (_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.enableJsdToJsm
          }
        }),
        filters: this.props.filters
      },
      perspective: this.props.perspective,
      stateChangeRequested: this.props.stateChangeRequested
    }));
  }

}

_defineProperty(HeroWrapper, "propTypes", {
  heroComponent: PropTypes.func.isRequired,
  filters: CommonPropTypes.filters.isRequired,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  stateChangeRequested: PropTypes.func.isRequired,
  enableJsdToJsm: PropTypes.bool
});

export default withFeatureFlags(HeroWrapper);